import { deleteApi, getApi, postApi } from "../../src/apis";

export const getWishlist = (id) => {
    return getApi(`/api/users/${id}/get-wishlist`);
};

export const addToWishlist = (userID, id) => {
    return postApi(`/api/users/${userID}/add-wishlist`, { propertyId: id });
};
export const removeFromWishlist = (id) => {
    return deleteApi("/api/remove/" + id);
};

export const clearWishlist = (id) => {
    return deleteApi("/api/clear/" + id);
};
